/* Coffao · Atelier équipe (devis)
   Amélioration progressive : sans JS, le formulaire s'envoie quand même. */
(function () {
  'use strict';

  function init(root) {
    var form = root.querySelector('#cf-ae-form');

    // Après envoi réussi : focus sur la confirmation
    var done = root.querySelector('[data-cf-ae-done]');
    if (done) { done.focus({ preventScroll: false }); return; }
    if (!form) return;

    form.noValidate = true; // on gère la validation nous-mêmes

    var nb = form.querySelector('#cf-ae-nb');
    var dateIn = form.querySelector('[data-cf-ae-date]');
    var flexIn = form.querySelector('[data-cf-ae-flex]');
    var warn = form.querySelector('[data-cf-ae-warn]');
    var ok = form.querySelector('[data-cf-ae-ok]');
    var sessTxt = form.querySelector('[data-cf-ae-sess]');
    var sessField = form.querySelector('[data-cf-ae-sessions-field]');
    var summary = form.querySelector('[data-cf-ae-summary]');

    var MIN = 2, MAX = 80, DELAI = 21;

    function today() { var d = new Date(); d.setHours(0, 0, 0, 0); return d; }
    function iso(d) {
      var m = String(d.getMonth() + 1).padStart(2, '0'), j = String(d.getDate()).padStart(2, '0');
      return d.getFullYear() + '-' + m + '-' + j;
    }
    if (dateIn) dateIn.min = iso(today());

    function clampN() {
      var v = parseInt(nb.value, 10);
      if (isNaN(v)) v = MIN;
      v = Math.min(MAX, Math.max(MIN, v));
      nb.value = v;
      return v;
    }

    function setAll(key, text) {
      root.querySelectorAll('[data-cf-ae-r="' + key + '"]').forEach(function (el) { el.textContent = text; });
    }

    function checked(name) { return form.querySelector('input[name="' + name + '"]:checked'); }

    function update() {
      var n = clampN();
      var fmt = checked('contact[Atelier]');
      var nom = fmt ? fmt.dataset.nom : 'À choisir';
      var cap = fmt ? parseInt(fmt.dataset.cap, 10) || 0 : 0;

      var long = 'On adapte le format et le nombre de sessions à ton effectif.';
      var court = 'À définir';
      if (cap > 0) {
        var k = Math.ceil(n / cap), lo = Math.floor(n / k), hi = Math.ceil(n / k);
        court = k === 1 ? '1 session' : k + ' sessions';
        long = k === 1
          ? n + ' personnes en ' + nom.toLowerCase() + ' : une seule session, tout le monde ensemble.'
          : n + ' personnes en ' + nom.toLowerCase() + ' : ' + k + ' groupes de ' + (lo === hi ? lo : lo + ' à ' + hi) + ', en parallèle ou à la suite selon le lieu.';
      }
      sessTxt.textContent = long;
      if (sessField) sessField.value = court;

      // Date
      var dateTxt = 'À définir';
      warn.hidden = true; ok.hidden = true;
      if (dateIn && dateIn.value) {
        var d = new Date(dateIn.value + 'T00:00:00');
        if (!isNaN(d)) {
          var jours = Math.round((d - today()) / 864e5);
          warn.hidden = jours >= DELAI;
          ok.hidden = jours < DELAI;
          dateTxt = d.toLocaleDateString('fr-FR', { weekday: 'short', day: 'numeric', month: 'long' });
        }
      }
      if (flexIn && flexIn.checked) dateTxt += ' (flexible)';

      var moment = checked('contact[Moment]');
      var opts = Array.prototype.map.call(form.querySelectorAll('[data-cf-ae-opt]:checked'), function (el) { return el.dataset.cfAeOpt; });

      setAll('fmt', nom);
      setAll('n', n + ' participants');
      setAll('sess', court);
      setAll('date', dateTxt);
      setAll('moment', moment ? moment.value : 'À définir');
      setAll('opts', opts.length ? opts.join(', ') : 'Aucune');
    }

    form.querySelector('[data-cf-ae-dec]').addEventListener('click', function () { nb.value = clampN() - 1; update(); });
    form.querySelector('[data-cf-ae-inc]').addEventListener('click', function () { nb.value = clampN() + 1; update(); });
    form.addEventListener('change', update);
    nb.addEventListener('input', function () { if (nb.value !== '') update(); });

    // Validation
    var EMAIL = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;
    function check(input) {
      var err = form.querySelector('#' + input.id + '-err');
      var bad = !input.value.trim() || (input.hasAttribute('data-cf-ae-email') && !EMAIL.test(input.value.trim()));
      input.setAttribute('aria-invalid', bad ? 'true' : 'false');
      if (err) { err.textContent = bad ? input.dataset.cfAeReq : ''; err.hidden = !bad; }
      return !bad;
    }
    var required = form.querySelectorAll('[data-cf-ae-req]');
    required.forEach(function (input) {
      input.addEventListener('blur', function () { if (input.value.trim()) check(input); });
      input.addEventListener('input', function () { if (input.getAttribute('aria-invalid') === 'true') check(input); });
    });

    form.addEventListener('submit', function (e) {
      var firstBad = null, count = 0;
      required.forEach(function (input) { if (!check(input)) { count++; if (!firstBad) firstBad = input; } });
      if (count) {
        e.preventDefault();
        summary.textContent = count === 1 ? 'Il manque une info pour envoyer ta demande.' : 'Il manque ' + count + ' infos pour envoyer ta demande.';
        summary.hidden = false;
        firstBad.focus();
        return;
      }
      summary.hidden = true;
      update(); // s'assure que le champ caché des sessions est à jour
    });

    update();
  }

  function boot() { document.querySelectorAll('[data-cf-ae]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target.querySelector('[data-cf-ae]'); if (r) init(r);
  });
})();